export default __webpack_public_path__ + "static/media/movie_transfers.cd267cec.jpg";